module.exports = __webpack_public_path__ + "static/media/cef.4f84fd19.png";